class JavascriptService {

	appendScript(scriptToAppend, scriptAsync, onLoad, onError) {
		const allSuspects = document.getElementsByTagName('script');
		let doAppend = true;
		if (allSuspects && allSuspects.length > 0) {
			for (let i = allSuspects.length - 1; i >= 0; i--) {
				if (allSuspects[i] && allSuspects[i].getAttribute('src') !== null
					&& allSuspects[i].getAttribute('src').indexOf(`${scriptToAppend}`) !== -1) {
					doAppend = false;
				}
			}
		}

		if (doAppend) {
			const script = document.createElement('script');
			script.src = scriptToAppend;
			script.async = scriptAsync;
			script.onload = () => onLoad();
			script.onerror = () => onError();
			document.body.appendChild(script);
		}
	}

	removeScript(scriptToRemove, callbackFn) {
		const allSuspects = document.getElementsByTagName('script');
		for (let i = allSuspects.length - 1; i >= 0; i--) {
			if (allSuspects[i] && allSuspects[i].getAttribute('src') !== null
				&& allSuspects[i].getAttribute('src').indexOf(`${scriptToRemove}`) !== -1) {
				allSuspects[i].parentNode.removeChild(allSuspects[i]);
			}
		}
		if (callbackFn) {
			callbackFn()
		}
	}
}

const javascriptService = new JavascriptService();
export default javascriptService;
